import React from 'react';
import { Timer, Sparkles, ExternalLink } from 'lucide-react';

const ScheduleInfoCard = ({ interval }) => {
    const isAuto = interval === 'auto' || String(interval).toLowerCase() === 'auto';
    
    const fmtInterval = (m) => {
        const num = parseInt(m, 10);
        if (isNaN(num)) return m;
        if (num < 60) return `${num} minutes`;
        const h = Math.floor(num / 60);
        const r = num % 60;
        return r ? `${h} hr ${r} min` : `${h} hr`;
    };

    if (!isAuto) {
        return (
            <div className="tw-rounded-xl tw-border tw-border-solid tw-border-blue-100 tw-overflow-hidden tw-mt-1 tw-w-full tw-max-w-[400px]">
              <div className="tw-flex tw-items-center tw-gap-3 tw-px-3.5 tw-py-3 tw-bg-blue-50">
                <Timer className="tw-w-5 tw-h-5 tw-text-link-blue tw-shrink-0" />
                <div className="tw-min-w-0 tw-flex-1">
                  <div className="tw-text-[13.5px] tw-font-medium tw-text-text-heading tw-mb-0.5">Every {fmtInterval(interval)}</div>
                  <div className="tw-text-[11.5px] tw-text-text-muted tw-leading-tight">Inherited from the global default</div>
                </div>
                <span className="tw-text-[11px] tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-white tw-border tw-border-solid tw-border-blue-100 tw-text-link-blue tw-font-medium">Global</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-px-3.5 tw-py-2.5 tw-bg-white tw-border-0 tw-border-t tw-border-solid tw-border-gray-100">
                <span className="tw-text-[11.5px] tw-text-text-muted tw-flex-1 tw-leading-tight">Set for all datasets. Change the interval in Configure.</span>
                <a href="/configure#scan-interval-settings" className="btn-sm tw-shrink-0 tw-inline-flex tw-items-center tw-gap-1 tw-text-[12px] tw-font-semibold tw-text-text-heading tw-bg-white tw-border tw-border-solid tw-border-[#E5E7EB] tw-px-2.5 tw-py-1 tw-rounded-md hover:tw-bg-gray-50 tw-no-underline hover:tw-no-underline">
                  Configure <ExternalLink className="tw-w-3.5 tw-h-3.5" />
                </a>
              </div>
            </div>
        );
    } else {
        return (
            <div className="tw-rounded-xl tw-border tw-border-solid tw-border-emerald-100 tw-overflow-hidden tw-mt-3 tw-w-full tw-max-w-[400px]">
              <div className="tw-flex tw-items-center tw-gap-3 tw-px-3.5 tw-py-3 tw-bg-emerald-50">
                <Sparkles className="tw-w-5 tw-h-5 tw-text-emerald-600 tw-shrink-0" />
                <div className="tw-min-w-0 tw-flex-1">
                  <div className="tw-text-[13.5px] tw-font-medium tw-text-text-heading tw-mb-0.5">Qualdo picks the time</div>
                  <div className="tw-text-[11.5px] tw-text-text-muted tw-leading-tight">Scans on new or refreshed data</div>
                </div>
                <span className="tw-text-[11px] tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-white tw-border tw-border-solid tw-border-emerald-100 tw-text-emerald-700 tw-font-medium">Global</span>
              </div>
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-px-3.5 tw-py-2.5 tw-bg-white tw-border-0 tw-border-t tw-border-solid tw-border-gray-100">
                <span className="tw-text-[11.5px] tw-text-text-muted tw-flex-1 tw-leading-tight">No fixed timer. Switch modes in Configure.</span>
              <a href="/configure#scan-interval-settings" className="btn-sm tw-shrink-0 tw-inline-flex tw-items-center tw-gap-1 tw-text-[12px] tw-font-semibold tw-text-text-heading tw-bg-white tw-border tw-border-solid tw-border-[#E5E7EB] tw-px-2.5 tw-py-1 tw-rounded-md hover:tw-bg-gray-50 tw-no-underline hover:tw-no-underline">
                  Configure <ExternalLink className="tw-w-3.5 tw-h-3.5" />
                </a>
              </div>
            </div>
        );
    }
};

export default ScheduleInfoCard;
